import React, { useState, useEffect } from 'react';
import {
    View,
    Text,
    TouchableOpacity,
    ScrollView,
    Image,
    ActivityIndicator,
    Linking,
    Platform
} from 'react-native';
import { useNavigation } from '@react-navigation/native';
import axios from 'axios';
import BaseWeb from '../components/baseWeb';
import styles from '../styles/celerWebStyles';
import { useLogScreen } from '../../useLogScreen';
export default function ListaAnaliseWeb() {
    useLogScreen('ListaAnaliseWeb');
    useEffect(() => {
        if (Platform.OS === 'web') {
            setTimeout(() => {
                document.title = 'imoGo | Solicitações';
            }, 100);
        }
    }, []);
    const navigation = useNavigation();
    const [analyses, setAnalyses] = useState([]);
    const [loading, setLoading] = useState(false);
    const [userInfo, setUserInfo] = useState(null);

    const fetchAnaliseData = async (usuario_id) => {
        setLoading(true);
        try {
            const response = await axios.get(`https://analise3.imogo.com.br/analises/usuario/${usuario_id}`);
            setAnalyses(response.data);
        } catch (error) {
            console.error('Erro ao buscar os dados do imóvel:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (userInfo?.id) {
            fetchAnaliseData(userInfo.id);
        }
    }, [userInfo]);

    const AnalysisCard = ({ id, date, status }) => {
        const getStatusText = (status) => {
            switch (status) {
                case 'em_progresso':
                    return 'Em Progresso';
                case 'concluida':
                    return 'Concluída';
                case 'pendente':
                    return 'Pendente';
                default:
                    return status;
            }
        };

        const handlePress = () => {
            if (status === 'pendente') {
                navigation.navigate('EtapasAnaliseWeb', {
                    usuario_id: userInfo.id,
                    analise_id: id,
                    status: 2,
                });
            } else {
                navigation.navigate('AnaliseDetalheWeb', {
                    usuario_id: userInfo.id,
                    id,
                });
            }
        };

        // const formatDate = (dateString) => {
        //     const [year, month, day] = dateString.split('-');
        //     return `${day}/${month}/${year}`;
        // };

        const formatDate = (dateString) => {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Meses começam do 0
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        };

        return (
            <View style={styles.optionButtonsContainer}>
                <TouchableOpacity style={styles.optionButton} onPress={handlePress}>
                    <Image
                        source={require('../../assets/icons/download.png')}
                        style={styles.optionIcon}
                    />
                    <View style={styles.optionTextContainer}>
                        <Text style={styles.optionTextTitle} allowFontScaling={false}>
                            Emissão de certidões #{id}
                        </Text>
                        <Text
                            style={[styles.optionTextSubtitle, styles.cardStatus(status)]}
                            allowFontScaling={false}
                        >
                            {getStatusText(status)}
                            <Text style={styles.optionTextSubtitle} allowFontScaling={false}>
                                {' '}| {formatDate(date)}
                            </Text>
                        </Text>
                    </View>
                </TouchableOpacity>
            </View>
        );
    };

    return (
        <BaseWeb>
            {(user) => {
                if (!userInfo) setUserInfo(user);

                return (
                    <ScrollView contentContainerStyle={styles.contentMinimal}>
                        <Text style={styles.title}>Minhas Emissões</Text>

                        <View style={styles.container}>
                            {loading ? (
                                <ActivityIndicator size="large" color="#730d83" style={{ marginTop: 30 }} />
                            ) : (
                                analyses.length > 0 ? (
                                    analyses.map((item) => (
                                        <AnalysisCard
                                            key={item.id}
                                            id={item.id}
                                            date={item.data}
                                            status={item.status}
                                        />
                                    ))
                                ) : (
                                    <Text style={[styles.checkboxLabel, { marginTop: 20 }]}>
                                        Nenhuma emissão encontrada.
                                    </Text>
                                )
                            )}
                        </View>
                    </ScrollView>
                );
            }}
        </BaseWeb>
    );
}
